/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ since: NonNullable<unknown> }} Vendor_Return_Waiting_On_CancellationInputs */

const en_vendor_return_waiting_on_cancellation = /** @type {(inputs: Vendor_Return_Waiting_On_CancellationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Waiting on the warehouse and Business Central · cancellation · since ${i?.since}`)
};

/**
* | output |
* | --- |
* | "Waiting on the warehouse and Business Central · cancellation · since {since}" |
*
* @param {Vendor_Return_Waiting_On_CancellationInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const vendor_return_waiting_on_cancellation = /** @type {((inputs: Vendor_Return_Waiting_On_CancellationInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vendor_Return_Waiting_On_CancellationInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_vendor_return_waiting_on_cancellation(inputs)
});